let nextModalId = 1;
const modalStack = [];
const listeners = new Set();

function notifyModalStack() {
  for (const listener of listeners) listener();
}

function keepRemainingModalScrollLocked(documentRef = globalThis.document) {
  if (!modalStack.length || !documentRef) return;
  documentRef.body.style.overflow = 'hidden';
  documentRef.documentElement.style.overflow = 'hidden';
}

export function registerModal(id = `talent-modal-${nextModalId++}`) {
  modalStack.push(id);
  keepRemainingModalScrollLocked();
  notifyModalStack();
  return id;
}

export function unregisterModal(id) {
  const index = modalStack.lastIndexOf(id);
  if (index === -1) return;
  modalStack.splice(index, 1);
  notifyModalStack();

  if (modalStack.length) {
    queueMicrotask(() => keepRemainingModalScrollLocked());
  }
}

export function isTopmostModal(id) {
  return modalStack.at(-1) === id;
}

export function getModalStackSize() {
  return modalStack.length;
}

export function subscribeModalStack(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function clearModalStackForTests() {
  modalStack.splice(0, modalStack.length);
  listeners.clear();
  nextModalId = 1;
}
